import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantPermissionAreaCargoComponent from "./components/MantPermissionAreaCargoComponent";
const MySwal = withReactContent(Swal);

const PagePermissionAreaCargoComponents = () => {
    const navigate = useNavigate();
    const location = useLocation();
       

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    // const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [areas, setAreas] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [cargos, setCargos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [cargosSelect, setCargosSelect] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [componentes, setComponentes] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [permisos, setPermisos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
  
    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();

    const createDataPermissionComponent = async (form) => {
        // form['usuario_registro'] = getUser();
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.PERMISOS_AREAS_CARGOS}/guardar`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), loadData, form);
    };
    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.PERMISOS_AREAS_CARGOS}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setAreas(rpta.data.areas);
                setCargos(rpta.data.cargos);
            }
        });
    };

    const searchPermissions = () => {
        let areaId = document.getElementById('areaId').value;
        let cargoId = document.getElementById('cargoId').value;

        if (areaId && cargoId) {
            setComponentes(CONFIGURACIONES.INIT.ARRAY);
            Http().get(`${CONFIGURACIONES.ENDPOINTS.AREAS_EMPLEADO}/${areaId}/cargos/${cargoId}/permisos`).then((rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    setComponentes(rpta.data.componentes);
                }
            });
        } else {
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Indique Área y Cargo para realizar búsqueda`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
        }
    };

    const changeArea = (value) => {
        console.log('select value', value);
        setCargosSelect(cargos.filter(cargo => cargo.area_empleado_id == value));
    };
    
    const searchPermissionsUser = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissionsUser(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantPermissionAreaCargoComponent title={'Gestión de Permisos de Componentes por Área y Cargo'} idEdit={idRef} closeSection={loadData}
                                        MySwal={MySwal} idRef={idRef} setIdRef={setIdRef} createData={createDataPermissionComponent} permisos={permisos} componentes={componentes}
                                        setComponentes={setComponentes} areas={areas} cargos={cargosSelect}
                                        fnBuscar={searchPermissions} icon={iconActive} showCreate={searchPermissionsUser(CONFIGURACIONES.ACTIONS.CREAR)}
                                        showEdit={searchPermissionsUser(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} changeArea={changeArea}/>
                                </div>
                            </div>
                        </div>
                    )}
                       
                </div>
            </div>
        </div>
    )
}

export default PagePermissionAreaCargoComponents;